
const TICK   = '\'';
const PERIOD = '.';
const ZERO   = '0';

/*   --------------------------------------------------------------------   */

export default class PriceFormat
    {

	/*   ----------------------------------------------------------------   */

     public static getFlaggedDisplayFormat(dNormVal    : number,
									       sFormatCode : string)
     {
     var sDispVal  : string | null = null;
     var dNormVal  : number;
     var dDispVal  : number;
     var dFraction : number;
     var iFraction : number;
     var iPoints   : number;
     var bNegative : boolean = false;
     var dOrgPrice           = dNormVal; 

	/*   ----------------------------------------------------------------   */

	if (dNormVal < 0)
		{
		bNegative = true;
		dNormVal  = -dNormVal;
		}

	/*   ----------------------------------------------------------------   */

    switch(sFormatCode)
      {
	  case "A" :                          /* Denominator 2 */
	       dDispVal = dNormVal * 10;
	       sDispVal = insertSep(dDispVal.toString(), TICK, 1);
	       break;

	  case "B" :                         /* Denominator 4 */
	  case "04":
	       iPoints   = Math.trunc(dNormVal);
	       dFraction = dNormVal - iPoints;
	       dDispVal  = (iPoints * 10) + (dFraction * 8);
	       sDispVal  = insertSep(dDispVal.toString(), TICK, 1);

	       if (iPoints == 0)
		    {
		    sDispVal = insertSep(sDispVal, ZERO, sDispVal.length);
		    }
	       break;

	  case "C" :                /* Denominator 4 */
	       iPoints  = Math.trunc(dNormVal * 10);
	       sDispVal = insertSep(iPoints.toString(), TICK, 1);
	       break;

	  case "H" :           /* Denominator 128 */
	  case "EH":
	       iPoints   = Math.trunc(dNormVal);
	       dFraction = dNormVal - iPoints;
	       dDispVal  = (iPoints * 1000) + (dFraction * 32 * 10);

		  //new
		  sDispVal  = Reformat(dDispVal.toString(), 3);
		  sDispVal  = insertSep(sDispVal, TICK, 3);	       
		  //endnew

		  //sDispVal  = insertSep(Convert.ToString(dDispVal), TICK, 3);

	       if (iPoints == 0)
		    {
		    sDispVal = insertSep(sDispVal, ZERO, sDispVal.length);
		    }
	       break;

	  case "D" :                         /* Denominator 8 */
	  case "08":
	       iPoints   = Math.trunc(dNormVal);
	       dFraction = dNormVal - iPoints;
	       dDispVal  = (iPoints * 10) + (dFraction * 8);
	       sDispVal  = insertSep(dDispVal.toString(), TICK, 1);

	       if (iPoints == 0)
		    {
		    sDispVal = insertSep(sDispVal, ZERO, sDispVal.length);
		    }
	       break;

	  case "F" :                /* Denominator 128 */
	  case "32":
	       iPoints   = Math.trunc(dNormVal);
	       dFraction = dNormVal - iPoints;
	       dDispVal  = (iPoints * 100) + (dFraction * 32);
	       sDispVal  = insertSep(dDispVal.toString(), TICK, 2);

	       if (iPoints == 0)
		    {
		    sDispVal = insertSep(sDispVal, ZERO, sDispVal.length);
		    }
	       break;

	  case "G" :                  /* Denominator 64 */
	  case "64":
	       iPoints   = Math.trunc(dNormVal);
	       dFraction = dNormVal - iPoints;
	       dDispVal  = (iPoints * 100) + (dFraction * 64);

		  if (dDispVal < 10)
			sDispVal  = insertSep("0" + dDispVal.toString(), TICK, 2);
		  else
			sDispVal  = insertSep(dDispVal.toString(), TICK, 2);

	       if (iPoints == 0)
		    {
		    sDispVal = insertSep(sDispVal, ZERO, sDispVal.length);
		    }
	       break;

	  case "I" :        /* Denominator 128 */
	  case "EQ":
	       iPoints   = Math.trunc(dNormVal);
	       dFraction = dNormVal - iPoints;
	       iFraction = Math.trunc(dFraction * 32 * 10);
	       dDispVal  = (iPoints * 1000) + iFraction;
	       sDispVal  = insertSep(dDispVal.toString(), TICK, 3);

	       if (iPoints == 0)
		    {
		    sDispVal = insertSep(sDispVal, ZERO, sDispVal.length);
		    }
	       break;

	  case "J" :            /* Denominator 128 */
	  case "FH":
	       iPoints   = Math.trunc(dNormVal);
	       dFraction = dNormVal - iPoints;
	       dDispVal  = (iPoints * 1000) + (dFraction * 64 * 10);
	       sDispVal  = insertSep(dDispVal.toString(), TICK, 3);

	       if (iPoints == 0)
		    {
		    sDispVal = insertSep(sDispVal, ZERO, sDispVal.length);
		    }
	       break;

	  case "EE" :        /* Denominator 256 */
	       iPoints   = Math.trunc(dNormVal);
	       dFraction = dNormVal - iPoints;
	       iFraction = Math.trunc(dFraction * 32 * 10);
	       dDispVal  = (iPoints * 1000) + iFraction;
	       sDispVal  = insertSep(dDispVal.toString(), TICK, 3);

	       if (iPoints == 0)
		    {
		    sDispVal = insertSep(sDispVal, ZERO, sDispVal.length);
		    }
	       break;


	  case "O" :                          /* Denominator 1 */
	       sDispVal = replaceSep(dNormVal.toString(), TICK, 1);
	       break;

	  case "P" :                  /* Denominator 1 */
	       sDispVal = dNormVal.toString();
	       /*
	       sDispVal = insertSep(sPrice, PERIOD, 3);
	       */
	       break;

	  case "Q" :                     /* Denominator 1 */
	  case "01":
	       sDispVal = dNormVal.toString();
	       break;

	  case "N" :                  /* Denominator 1 */
	       sDispVal = replaceSep(dNormVal.toString(), TICK, 2);
	       /*
	       dNormVal = Convert.ToDouble(sPrice);
	       dDispVal = dNormVal * 100;
	       sDispVal = insertSep(Convert.ToString(dDispVal), TICK, 2);
	       */
	       break;

	  case "A1" :
	       dDispVal = dNormVal * 1000;
	       sDispVal = insertSep(dDispVal.toString(), TICK, 2);
	       break;

	  case "S" :          /* Denominator 2 */
	       sDispVal = appendChar(dNormVal.toString(), 1, ZERO);
	       break;

	  case "K" :                           /* Denominator 2 */
	       dDispVal = dNormVal * 10;
	       sDispVal = dDispVal.toString();
	       break;

	  case "L" :                     /* Denominator 2 */
	  case "02":
	       dDispVal = dNormVal * 10;
	       sDispVal = dDispVal.toString();
	       break;

	  case "M" :            /* Denominator 2 */
	       dDispVal = dNormVal * 10;
	       sDispVal = insertSep(dDispVal.toString(), TICK, 3);
	       break;

	  default :
	       return(dOrgPrice.toString());
	  }

	/*   ----------------------------------------------------------------   */

	if (bNegative == true)
		sDispVal = insertSep(sDispVal, '-', sDispVal.length);

     return(sDispVal);
     }

	/*   ----------------------------------------------------------------   */


	/*   ----------------------------------------------------------------   */

    }

    /*   ================================================================   */

    function Reformat(sPrice  : string,
                      iPlaces : number)
    {
    var sFormattedPrice = sPrice;

    for (var i = 0; i < iPlaces - sPrice.length; i++)
    sFormattedPrice = "0" + sFormattedPrice;

    return(sFormattedPrice);
    }

    /*   ----------------------------------------------------------------   */

    function insertSep(sInput  : string,
					   cSep    : string,
					   iPlaces : number)
     {
	try
		{
		var iLim : number;

		/*   -----------------------------------------------------------   */

		if (sInput.length < iPlaces)
			{
			iLim   = iPlaces - sInput.length;
			sInput = "0".repeat(iLim) + sInput;
			}

		/*   -----------------------------------------------------------   */

		return(insert(sInput, cSep, sInput.length - iPlaces));
		}
	catch
		{
		return(sInput);
		}
     }

	/*   ----------------------------------------------------------------   */

    function insert(sInput : string, 
                    cSep   : string,
                    iPos   : number) 
    {
    return (sInput.slice(0, iPos) + cSep + sInput.slice(iPos));
    }

    /*   ----------------------------------------------------------------   */

    function replaceSep(sInput  : string,
					    cSep    : string,
						iPlaces : number)
    {
    var acDispVal : Array<string>;
    var acNormVal : Array<string>;
    var iCur      : number;
    var iLim      : number;

	/*   ----------------------------------------------------------------   */

    acNormVal = [...sInput];
    acDispVal = new Array(acNormVal.length);

	/*   ----------------------------------------------------------------   */
     
    for (iCur = 0, iLim = acNormVal.length - iPlaces - 1; iCur < iLim; iCur++)
        {
	    acDispVal[iCur] = acNormVal[iCur];
	    }

	/*   ----------------------------------------------------------------   */

    acDispVal[iCur++] = cSep;

	/*   ----------------------------------------------------------------   */

    for(iLim = acNormVal.length; iCur < iLim; iCur++)
        {
	    acDispVal[iCur] = acNormVal[iCur];
	    }
     
     return (acDispVal.toString());
     }

	/*   ----------------------------------------------------------------   */

    function deleteSep(sInput  : string,
                       cSep    : string,
                       iPlaces : number)
    {
    var acDispVal : Array<string>;
    var acNormVal : Array<string>;
    var iCur      : number;
    var iLim      : number;
   
	/*   ----------------------------------------------------------------   */

    acNormVal = [...sInput];
    acDispVal = new Array(acNormVal.length - 1);

	/*   ----------------------------------------------------------------   */
     
    for(iCur = 0, iLim = acNormVal.length - iPlaces - 1; iCur < iLim; iCur++)
        {
	    acDispVal[iCur] = acNormVal[iCur];
        }

	/*   ----------------------------------------------------------------   */

    iCur++;

	/*   ----------------------------------------------------------------   */

    for(iLim = acNormVal.length; iCur < iLim; iCur++)
        {
	    acDispVal[iCur - 1] = acNormVal[iCur];
	    }

	/*   ----------------------------------------------------------------   */
     
    return (acDispVal.toString());
    }

	/*   ----------------------------------------------------------------   */

    function appendChar(sInput : string,
					    iCount : number,
						cChar  : string)
    {
    var acInput  : Array<string>;
    var acOutput : Array<string>;

	/*   ----------------------------------------------------------------   */

    acInput  = [...sInput];
    acOutput = new Array(acInput.length + iCount);

	/*   ----------------------------------------------------------------   */

    for(var i = 0; i < acInput.length; i++)
        {
	    acOutput[i] = acInput[i];
	    }

	/*   ----------------------------------------------------------------   */

    for(var i = 0; i < iCount; i++)
        {
	    acOutput[acInput.length + i] = cChar;
	    }

	/*   ----------------------------------------------------------------   */
     
    return (acOutput.toString());
    }

	/*   ----------------------------------------------------------------   */

    function deleteChar(sInput : string,
					    iCount : number)
    {
    var acInput  : Array<string>;
    var acOutput : Array<string>;

	/*   ----------------------------------------------------------------   */

    acInput  = [...sInput];
    acOutput = new Array(acInput.length - iCount);

	/*   ----------------------------------------------------------------   */

    for(var i = 0; i < acOutput.length; i++)
        {
	    acOutput[i] = acInput[i];
	    }

	/*   ----------------------------------------------------------------   */

    return (acOutput.toString());
    }